__turbopack_context__.v({
  "captchaWrapper": "ForgotPasswordForm-module-scss-module__Os-QHW__captchaWrapper",
});
